(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('FileStore', FileStore);

    FileStore.$inject = ['$resource'];

    function FileStore ($resource) {
        var resourceUrl =  'api/file-stores/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
